module.exports = __webpack_public_path__ + "img/e2.0c5a7e3d.jpg";